import React from "react";

import { listMyPendingAppointmentSnapshots } from "@/services/patientAppointmentSnapshots.js";

export default function useMyPendingAppointments() {
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");
  const [items, setItems] = React.useState([]);

  const load = React.useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const data = await listMyPendingAppointmentSnapshots();
      setItems(Array.isArray(data) ? data : []);
    } catch (e) {
      setItems([]);
      setError(e?.message || "Unable to load pending appointments.");
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    load();
    const onChanged = () => load();
    window.addEventListener("afrimed:appointments:changed", onChanged);
    return () => window.removeEventListener("afrimed:appointments:changed", onChanged);
  }, [load]);

  return { loading, error, items, refetch: load };
}
